import React, { useEffect, useState } from "react";
import {
    Container,
    Typography,
    TextField,
    Autocomplete,
    Button,
    Input,
    Card,
    CardContent,
    Grid,
    Backdrop,
    CircularProgress,
    MenuItem,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";

const ContractUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [crewLoading, setCrewLoading] = useState(false);

    const [formData, setFormData] = useState({
        vesselOwner: "",
        ShipDetails: "",
        rank: "",
        crewdetails: "",
        crewingAgent: "",
        BSM: null,
        RPSL: null,
        NOK: null,
        DrugAlcoholPolicy: null,
        CheckList: null,
        DeclarationForm: null,
        TravelTicket: null,
        LOG: null,
        Visa: null,
        SignedContract: null,
    });

    const [files, setFiles] = useState({
        BSM: null,
        RPSL: null,
        NOK: null,
        DrugAlcoholPolicy: null,
        CheckList: null,
        DeclarationForm: null,
        TravelTicket: null,
        LOG: null,
        Visa: null,
        SignedContract: null,
    });

    const [vesselData, setVesselData] = useState([]);
    const [vesselDetails, setVesselDetails] = useState([]);
    const [rankData, setRankData] = useState([]);
    const [crewingAgents, setCrewingAgents] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [rankName, setRankName] = useState("");

    const userId = localStorage.getItem("user id");

    useEffect(() => {
        fetchInitialData();
        fetchContractDetails();
    }, []);

    useEffect(() => {
        if (formData.rank) fetchCrewDetailsByRank(formData.rank);
    }, [formData.rank]);

    useEffect(() => {
        if (rankName) {
            fetchCrewDetailsByRank(rankName);
        }
    }, [rankName]);

    const fetchInitialData = async () => {
        try {
            const token = localStorage.getItem("token");
            const [vesselRes, rankRes, agentRes] = await Promise.all([
                  axios.get(`${baseURL}/api/getvesselownerforcontract`, {
                          headers: { Authorization: `Bearer ${token}` }, // Adding token here
                        }),
                axios.get(`${baseURL}/api/rankData`, {
                    headers: { Authorization: `Bearer ${token}` }, // Adding token here
                }),
                axios.get(`${baseURL}/api/crewingAgent/getApprovedCrewingAgent`, {
                    headers: { Authorization: `Bearer ${token}` }, // Adding token here
                },
                ),
            ]);
            setVesselData(vesselRes.data.data || []);
            setRankData(rankRes.data.data || []);
            setCrewingAgents(agentRes.data.data || []);
        } catch (error) {
            console.error("Error fetching initial data:", error);
            toast.error("Failed to fetch initial data");
        }
    };

    const fetchContractDetails = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get(`${baseURL}/api/getContractDetailsById/${id}`, {
                headers: { Authorization: `Bearer ${token}` }, 
            });
            const data = response.data;
            console.log("df", response.data)
            setFormData({
                vesselOwner: data?.contract?.vesselOwner || data?.vesselOwner,
                ShipDetails: data?.contract?.ShipDetails || data?.ShipDetails,
                rank: data?.contract?.rank || data?.rank,
                crewdetails: data?.contract?.crewdetails || data?.crewdetails,
                crewingAgent: data?.contract?.crewingAgent || data?.crewingAgent,
                BSM: data?.contract?.BSM || data?.BSM,
                RPSL: data?.contract?.RPSL || data?.RPSL,
                NOK: data?.contract?.NOK || data?.NOK,
                DrugAlcoholPolicy: data?.contract?.DrugAlcoholPolicy || data?.DrugAlcoholPolicy,
                CheckList: data?.contract?.CheckList || data?.CheckList,
                DeclarationForm: data?.contract?.DeclarationForm || data?.DeclarationForm,
                TravelTicket: data?.contract?.TravelTicket || data?.TravelTicket,
                LOG: data?.contract?.LOG || data?.LOG,
                Visa: data?.contract?.Visa || data?.Visa,
                SignedContract: data?.contract?.SignedContract || data?.SignedContract,
                contractDuration: data?.contract?.contractDuration || data?.contractDuration,
            });
        } catch (error) {
            console.error("Error fetching contract details:", error);
            toast.error("Error fetching contract details");
        } finally {
            setLoading(false);
        }
    };

    const fetchShipDetailsById = async (id) => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.post(`${baseURL}/api/vesselformbyagentById/${id}`, {} , {
                headers: { Authorization: `Bearer ${token}` }, // Adding token here
            },
            );
            setVesselDetails(response.data || []);
        } catch (error) {
            console.error("Error fetching ship details:", error);
            toast.error("Error fetching ship details");
        }
    };

    const fetchCrewDetailsByRank = async (rank) => {
        if (!rank) return;

        setCrewLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get(`${baseURL}/api/getAllCrewingDetails`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                  },
                  params: { rank },
            });
            setContracts(response?.data || []);
        } catch (error) {
            console.error("Error fetching crew details:", error);
            toast.error("Error fetching crew details");
        } finally {
            setCrewLoading(false);
        }
    };

    const handleChange = (event, value, field) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [field]: value,
        }));

        if (field === "vesselOwner" && value) fetchShipDetailsById(value._id);
        if (field === "rank" && value?.rankname) {
            setRankName(value.rankname);
        }
    };

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
            setFiles((prevFiles) => ({
                ...prevFiles,
                [type]: file,
            }));
            setFormData((prevFormData) => ({
                ...prevFormData,
                [type]: file,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formDataToSend = new FormData();
        formDataToSend.append("contractId", id);
        formDataToSend.append("creatorIdWithName", userId);

        Object.entries(formData).forEach(([key, value]) => {
            if (value && typeof value === "object" && value._id) {
                formDataToSend.append(key, value._id);
            } else if (!["BSM", "RPSL", "NOK", "DrugAlcoholPolicy", "CheckList", "DeclarationForm", "TravelTicket", "LOG","Visa", "SignedContract" ].includes(key)) {
                formDataToSend.append(key, value);
            }
        });

        // Append files if they exist
        Object.entries(files).forEach(([key, file]) => {
            if (file) {
                formDataToSend.append(key, file);
            } else if (formData[key]?.filePath) {
                formDataToSend.append(`existing${key}`, formData[key].filePath);
            }
        });

        try {
            const token = localStorage.getItem("token");
            await axios.put(`${baseURL}/api/update/${id}`, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,

                },

            });
            toast.success("Contract updated successfully!");
            setTimeout(() => {
                navigate("/ContractTable");
              }, 1000);
        } catch (err) {
            console.error("Error updating contract:", err);
            toast.error("Error updating contract: " + err.message);
        } finally {
            setLoading(false); // Hide loader once done
        }
    };

    return (
        <>
            <Navbar />
            {loading && (
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        backdropFilter: "blur(5px)",
                        display: "flex",
                        flexDirection: "column",
                    }}
                    open={loading}
                >
                    <CircularProgress color="inherit" size={60} />
                    <Typography
                        variant="h6"
                        color="inherit"
                        sx={{ marginTop: 2 }}
                    >
                        Submitting your contract...
                    </Typography>
                </Backdrop>
            )}

            <Container maxWidth="md" sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
                <Typography variant="h4" textAlign="center" gutterBottom>
                    Update Contract
                </Typography>
                <ToastContainer position="top-right" autoClose={3000} />

                {loading ? (
                    <p>Loading contract details...</p>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <Autocomplete
                            options={vesselData}
                            value={formData.vesselOwner || null}
                            getOptionLabel={(option) => option.company_shortname || ""}
                            onChange={(event, value) => handleChange(event, value, "vesselOwner")}
                            renderInput={(params) => <TextField {...params} label="Vessel Owner" required sx={{ mt: 2 }} />}
                        />
 
                        <Autocomplete
                            options={vesselDetails}
                            value={formData.ShipDetails || null}
                            getOptionLabel={(option) => option.vesselname || ""}
                            onChange={(event, value) => handleChange(event, value, "ShipDetails")}
                            renderInput={(params) => <TextField {...params} label="Vessel" required sx={{ mt: 2 }} />}
                        />
               
                        <Autocomplete
                            options={rankData}
                            value={formData.rank || null}
                            getOptionLabel={(option) => option.rankname || ""}
                            onChange={(event, value) => handleChange(event, value, "rank")}
                            renderInput={(params) => <TextField {...params} label="Rank" required sx={{ mt: 2 }} />}
                        />

                        <Autocomplete
                            options={contracts}
                            value={formData.crewdetails || null}
                            getOptionLabel={(option) => `${option.name || "Unnamed Crew"} (${option.indosno || "No INDOS No"})`}
                            onChange={(event, value) => handleChange(event, value, "crewdetails")}
                            renderInput={(params) => <TextField {...params} label="Crew Details" required sx={{ mt: 2 }} />}
                        />

                        <Autocomplete
                            options={crewingAgents}
                            value={formData.crewingAgent || null}
                            getOptionLabel={(option) => option.agentName || ""}
                            onChange={(event, value) => handleChange(event, value, "crewingAgent")}
                            renderInput={(params) => <TextField {...params} label="Crewing Agent" required sx={{ mt: 2 }} />}
                        />

                        {/* File Upload Fields */}
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                            {["BSM", "RPSL", "NOK", "DrugAlcoholPolicy", "CheckList", "DeclarationForm", "TravelTicket", "LOG","Visa", "SignedContract" ].map((type) => (
                                <Grid item xs={6} key={type}>
                                    <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                                        <CardContent>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                fullWidth
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 1,
                                                    py: 1.5,
                                                    backgroundColor: "#1976d2",
                                                    "&:hover": { backgroundColor: "#1565c0" },
                                                }}
                                            >
                                                <CloudUploadIcon />
                                                Upload {type}
                                                <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, type)} />
                                            </Button>

                                            {formData[type]?.filePath && (
                                                <Typography variant="body2" sx={{ mt: 1 }}>
                                                    Existing File:{" "}
                                                    <a
                                                        href={
                                                            formData[type].filePath.startsWith("http")
                                                                ? formData[type].filePath
                                                                : `${baseURL}/${formData[type].filePath.replace(/\\/g, "/")}`
                                                        }
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {formData[type].originalName}
                                                    </a>
                                                </Typography>
                                            )}

                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        <Grid container spacing={2} sx={{ mt: 2 }}>
  <Grid item xs={6}>
    <TextField
      label="Duration"
      type="number"
      fullWidth
      value={formData.contractDuration?.split(" ")[0] || ""}
      onChange={(e) => {
        const unit = formData.contractDuration?.split(" ")[1] || "months";
        setFormData({
          ...formData,
          contractDuration: `${e.target.value} ${unit}`,
        });
      }}
    />
  </Grid>
  <Grid item xs={6}>
    <TextField
      select
      label="Unit"
      fullWidth
      value={formData.contractDuration?.split(" ")[1] || "months"}
      onChange={(e) => {
        const number = formData.contractDuration?.split(" ")[0] || "1";
        setFormData({
          ...formData,
          contractDuration: `${number} ${e.target.value}`,
        });
      }}
    >
      <MenuItem value="days">Days</MenuItem>
      <MenuItem value="months">Months</MenuItem>
      <MenuItem value="years">Years</MenuItem>
    </TextField>
  </Grid>
</Grid>


                        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                            Update Contract
                        </Button>
                    </form>
                )}
            </Container>
        </>
    );
};

export default ContractUpdate;